/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Image
import adobeXD from "assets/images/foodpanda.png";
import atlassian from "assets/images/small-logos/logo-atlassian.svg";
import slack from "assets/images/small-logos/logo-slack.svg";
import spotify from "assets/images/small-logos/logo-spotify.svg";
import jira from "assets/images/small-logos/logo-jira.svg";

const complexReportsDoughnutChartDataMarketplaces = {
  images: [adobeXD, atlassian, slack, spotify, jira],
  labels: ["Food Panda", "Grab Food", "Zomato", "Lazada", "Uber Eats"],
  datasets: {
    label: "Smart Market Usage by App",
    backgroundColors: ["dark", "info", "primary", "success", "secondary"],
    data: [25, 3, 12, 7, 10],
  },
};

export default complexReportsDoughnutChartDataMarketplaces;
